import { useState, useEffect, useContext } from 'react'
import { Context } from '../../../utils/context'
import { Strings } from '../../../assets/res/en'
import { groupsEndPoints, merchantsEndPoints, profilesEndPoints, catalogsEndPoints } from '../../../utils/endpoints'
import usaFlag from '../../../assets/flags/united-states.png'
import mexicoFlag from '../../../assets/flags/mexico.png'

function useCommonMenus() {
    const { axios, authData } = useContext(Context)
    const authToken = `Bearer ${authData.token}`
    const [locationMenus, setLocationMenus] = useState([])
    const [groupsMenus, setGroupMenus] = useState([])
    const [programsMenus, setProgramsMenus] = useState([])
    const [profileMenus, setProfileMenus] = useState([])
    const [currencyCodeMenus, setCurrencyCodeMenus] = useState([])
    const [addressTypeMenus, setAddressTypeMenus] = useState([])
    const [countryMenus, setCountryMenus] = useState([])
    const [stateMenus, setStateMenus] = useState([])
    const [telephoneTypeMenus, setTelephoneTypeMenus] = useState([])
    const [glObj, setGLObj] = useState({
        program: '',
        group: '',
        location: ''
    })

    

    const programDummyData = [
        { text: "Prog1", val: 1 },
        { text: "Prog2", val: 2 },
        { text: "Prog3", val: 3 },
        { text: "Prog4", val: 4 },
    ]

    const [countryCodeMenus, setCountryCodeMenus] = useState([
        { text: "+1", val: "1", startAddornment: <img src={usaFlag} alt='' width={24} />},
        { text: "+52", val: "52", startAddornment: <img src={mexicoFlag} alt='' width={24} />},
    ])

    //get Programs
    useEffect(() => {
        setProgramsMenus(programDummyData.sort((a, b) => (a.text ?? "").localeCompare(b.text ?? "")))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    //get Groups
    useEffect(() => {
        axios.get(groupsEndPoints.getAll,
            { headers: { 'Authorization': authToken } })
            .then(res => {
                if (res.data.success) {
                    const { data } = res.data
                    const groupItems = data.map(g => ({
                        text: g.description,
                        val: g.idGroup
                    })).sort((a, b) => (a.text ?? "").localeCompare(b.text ?? ""))
                    setGroupMenus([
                        {
                            text: Strings.SEARCH_CASINO_GROUP,
                            val: ''
                        },
                        {
                            text: Strings.NO_GROUP,
                            val: 0
                        },
                        ...groupItems
                    ])
                }
            })
            .catch(err => err)

        axios.get(profilesEndPoints.getAll,
            { headers: { 'Authorization': authToken } })
            .then(res => {
                if (res.data.success) {
                    const { data } = res.data
                    const profileItems = data.map(g => ({
                        text: g.name ?? g.description ?? "N/A",
                        val: g.idProfile
                    })).sort((a,b)=>a.text.localeCompare(b.text))
                    setProfileMenus(profileItems)
                }
            })
            .catch(err => err)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    //get Locations On Group Chnage
    useEffect(() => {
        setLocationMenus([
            {
                text: Strings.SEARCH_CASINO_LOCATION,
                val: ''
            },
            {
                text: Strings.NO_LOCATION,
                val: 0
            },
        ])
        setGLObj(prevData => ({
            ...prevData,
            location: ''
        }))
        if (glObj.group > 0) {
            let merchantByGroupId = `${merchantsEndPoints.getMerchantByGroupID}/${glObj.group}`
            axios.get(merchantByGroupId,
                { headers: { 'Authorization': authToken } })
                .then(res => {
                    if (res.status === 200) {
                        const { data } = res.data
                        const locationItems = data.map(g => ({
                            text: g.description,
                            val: g.idMerchant
                        })).sort((a, b) => (a.text ?? "").localeCompare(b.text ?? ""))
                        setLocationMenus(prevData => [
                            ...prevData,
                            ...locationItems
                        ])
                    }
                })
                .catch(err => err)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [glObj.group])

    //get Currency Code Menus
    const currencyCodeDummyData = [
        { text: "US Dollar", val: 840 },
        //{ text: "US Dollar 1", val: 841 },
        //{ text: "US Dollar 2", val: 842 },
        //{ text: "US Dollar 3", val: 843 },
        // { idCurrencyCode: 840, code: "USD", description: "US Dollar" },
    ]
    useEffect(() => {
        setCurrencyCodeMenus(currencyCodeDummyData.sort((a, b) => (a.text ?? "").localeCompare(b.text ?? "")))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    //get Address Type Menus
    const addressTypeDummyData = [
        { text: "Unknown", val: 0 },
        { text: "DOMICILIO PARTICULAR", val: 1 },
        { text: "Work/Office", val: 2 }
    ]
    useEffect(() => {
        setAddressTypeMenus(addressTypeDummyData.sort((a, b) => (a.text ?? "").localeCompare(b.text ?? "")))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    //get Country
    useEffect(() => {
        axios.get(catalogsEndPoints.getAllCountry,
            { headers: { 'Authorization': authToken } })
            .then(res => {
                if (res.status === 200) {
                    const { data } = res.data
                    const countryItems = data.map(c => ({
                        text: c.shortDescription,
                        val: c.idCountry
                    })).sort((a, b) => (a.text ?? "").localeCompare(b.text ?? ""))
                    setCountryMenus([
                        {
                            text: Strings.SEARCH_COUNTRY,
                            val: 0
                        },
                        ...countryItems
                    ])
                }
            })
            .catch(err => err)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    //get State
    useEffect(() => {
        axios.get(catalogsEndPoints.getStates,
            { headers: { 'Authorization': authToken } })
            .then(res => {
                if (res.status === 200) {
                    const { data } = res.data
                    const stateItems = data.map(c => ({
                        text: c.description,
                        val: c.idState,
                        idCountry: c.idCountry
                    })).sort((a, b) => (a.text ?? "").localeCompare(b.text ?? ""))
                    setStateMenus([
                        {
                            text: Strings.SEARCH_STATE,
                            val: 0
                        },
                        ...stateItems
                    ])
                }
            })
            .catch(err => err)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    //get Telephone Type
    useEffect(() => {
        axios.get(catalogsEndPoints.getAllTelephoneType,
            { headers: { 'Authorization': authToken } })
            .then(res => {
                if (res.status === 200) {
                    const { data } = res.data
                    const telephoneTypeItems = data.map(t => ({
                        text: t.description,
                        val: t.idTelephoneType
                    })).sort((a, b) => (a.text ?? "").localeCompare(b.text ?? ""))
                    setTelephoneTypeMenus([...telephoneTypeItems])
                }
            })
            .catch(err => err)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return {
        locationMenus,
        groupsMenus,
        programsMenus,
        profileMenus,
        glObj,
        setGLObj,
        currencyCodeMenus,
        addressTypeMenus,
        countryMenus,
        stateMenus,
        telephoneTypeMenus,
        countryCodeMenus
    }
}

export default useCommonMenus